// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"f2858c0d","247":"ba9ec58a","284":"eea7e6a9","453":"5e508768","627":"5262bea3","834":"aba3e359","867":"3d7508b7","923":"589665f9","938":"d755215b","952":"aca0b0fb"}[chunkId] + ".chunk.js";
};